import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexFill,
  ApexLegend,
  ApexNonAxisChartSeries,
  ApexPlotOptions,
  ApexStroke,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis
} from 'ng-apexcharts';
import {FormValueTypeEnum, IconTypeEnum} from '../enums/data.enums';

export enum UserTypeEnum {
  Staff = 'Staff',
  External = 'External',
  GUEST = 'GUEST',
  INTERNAL = 'INTERNAL'
}

export interface AuthUser {
  [key: string]: any;
}

export interface PageableParam {
  pageNumber?: number;
  pageSize?: number;
  first?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: string;
  searchFields?: SearchFieldsDtoInput[];
  searchCombinationType?: SearchCombinationTypeEnum;
}

export interface SearchFieldsDtoInput {
  fieldName?: string;
  fieldValue?: any;
  fieldValues?: any[];
  searchType?: SearchOperationType;
}

export enum SearchCombinationTypeEnum {
  And = 'And',
  Or = 'Or'
}

export enum SearchOperationType {
  Equal = 'Equal',
  Like = 'Like',
  GreaterThan = 'GreaterThan',
  LessThan = 'LessThan',
  Between = 'Between',
  In = 'In'
}

// import {ReportTFBMenuEnum} from '../../modules/report/report-tfb/report-tfb';
// import {ReportBasataMenuEnum} from '../../modules/report/report-basata/report-basata';

export interface MenuItem {
  name: string;
  description?: string;
  lang?: string;
  route?: string;
  iconType?: string;
  icon?: string;
  permissions?: string[];
  url?: string;
  disabled?: boolean;
  isHint?: boolean;
  userType?: string;
  children?: MenuItem[];
  logo?: string;
}

export interface SvgIcon {
  name: string;
  tag: string;
}



export interface AuthTokenModel {
  access: string;
  refresh: string;
  accessTokenExpiresIn?: string;
}

export interface ResponseCode {
  code: number;
  description: string;
}

export interface NotificationMenuItem extends MenuItem{
  title?: string;
  total?: number;
  query: any;
  variables?: object;
}


export interface ChartOptions {
  chart: ApexChart;
  series: ApexAxisChartSeries;
  xaxis: ApexXAxis;
  yaxis?: ApexYAxis;
  dataLabels?: ApexDataLabels;
  plotOptions?: ApexPlotOptions;
  title?: ApexTitleSubtitle;
  stroke?: ApexStroke;
  fill?: ApexFill;
  legend?: ApexLegend;
  labels?: string[];
  colors?: string[];
}



export interface DialogButtons {
  title?: string;
  value?: any;
}

export interface DialogData {
  icon?: string;
  iconType?: IconTypeEnum;
  title?: string;
  message?: string;
  placeholder?: string;
  isForm?: boolean;
  formFieldType?: FormValueTypeEnum;
  dialogValue?: any;
  buttons?: DialogButtons[];
}
